import React, {useState, useContext} from "../../_snowpack/pkg/react.js";
import {GlobeIcon, EmojiSadIcon} from "../../_snowpack/pkg/@heroicons/react/outline.js";
import {trackWindowScroll} from "../../_snowpack/pkg/react-lazy-load-image-component.js";
import AmiiboCard from "./AmiiboCard.js";
import AmiiboDialog from "./AmiiboDialog.js";
import {SettingsContext} from "../App.js";
import {useAmiiboSearch, useAutocomplete} from "../hooks/search-hook.js";
const SearchResults = ({name, scrollPosition}) => {
  const {data, isLoading} = useAmiiboSearch(name);
  const [amiibo, setAmiibo] = useState(null);
  const suggestions = useAutocomplete(name);
  const [settings] = useContext(SettingsContext);
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(AmiiboDialog, {
    amiiboState: [amiibo, setAmiibo],
    darkMode: settings.darkMode
  }), isLoading ? /* @__PURE__ */ React.createElement("div", {
    className: "grid h-screen justify-center content-center"
  }, /* @__PURE__ */ React.createElement(GlobeIcon, {
    className: "w-32 h-32 animate-pulse text-gray-400 dark:text-white"
  })) : data && "amiibo" in data ? /* @__PURE__ */ React.createElement("div", {
    className: `grid gap-2 m-2 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4`
  }, data.amiibo.map((amiibo2) => /* @__PURE__ */ React.createElement(AmiiboCard, {
    key: amiibo2.character + "-" + amiibo2.head + amiibo2.tail,
    amiibo: amiibo2,
    onExpand: () => setAmiibo(amiibo2),
    scrollPosition
  }))) : /* @__PURE__ */ React.createElement("div", {
    className: "grid h-screen justify-center content-center dark:text-white"
  }, /* @__PURE__ */ React.createElement(EmojiSadIcon, {
    className: "w-32 h-32 text-gray-400 dark:text-white mx-auto"
  }), name !== "" ? /* @__PURE__ */ React.createElement("p", null, "No search results for ", name) : /* @__PURE__ */ React.createElement("p", null, "Try searching for something"), suggestions.length !== 0 && name.length >= 3 && /* @__PURE__ */ React.createElement(React.Fragment, null, suggestions[0] !== name && /* @__PURE__ */ React.createElement("p", {
    className: "mx-auto"
  }, "Did you mean", " ", /* @__PURE__ */ React.createElement("span", {
    className: "text-red-500 dark:text-red-300"
  }, suggestions[0]), "?"))));
};
export default trackWindowScroll(SearchResults);
